import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import {
  decodeGoogleCredentialJwt,
  googleAuthErrorMessage,
} from "./googleAuth";

/**
 * Preserves the existing .social button look while using GIS credential (JWT) login.
 * GoogleLogin is overlaid invisibly so clicks trigger Identity Services.
 *
 * Props:
 * - label: button text
 * - onDecoded(payload, credential): JWT payload + raw GIS credential string
 * - onError(message): user-facing error string
 * - disabled: boolean
 */
function GoogleSignInButton(props) {
  const { label, onDecoded, onError, disabled } = props;

  const emitError = function (codeOrMessage) {
    if (!onError) {
      return;
    }
    if (
      codeOrMessage === "cancelled" ||
      codeOrMessage === "invalid" ||
      codeOrMessage === "expired" ||
      codeOrMessage === "network" ||
      codeOrMessage === "unknown"
    ) {
      onError(googleAuthErrorMessage(codeOrMessage));
      return;
    }
    onError(codeOrMessage || googleAuthErrorMessage("unknown"));
  };

  const handleSuccess = function (credentialResponse) {
    if (!credentialResponse || !credentialResponse.credential) {
      emitError("invalid");
      return;
    }

    const result = decodeGoogleCredentialJwt(credentialResponse.credential);
    if (!result.ok) {
      emitError(result.code);
      return;
    }

    if (onDecoded) {
      onDecoded(result.payload, credentialResponse.credential);
    }
  };

  const handleError = function () {
    // GIS fires onError when the user closes the popup or sign-in fails
    emitError("cancelled");
  };

  return (
    <div
      className="social"
      style={{
        position: "relative",
        overflow: "hidden",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <span style={{ pointerEvents: "none" }}>
        <i className="fab fa-google-plus-square google social-icons" /> {label}
      </span>
      {!disabled ? (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            opacity: 0.011,
            overflow: "hidden",
          }}
        >
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            useOneTap={false}
            theme="outline"
            size="large"
            text="continue_with"
            shape="rectangular"
            width="400"
          />
        </div>
      ) : null}
    </div>
  );
}

export default GoogleSignInButton;
